export enum DeviceTypeEnum {
  MOBILE = 1,
  TABLET = 2,
  DESKTOP = 3
}
